<!-- <dashboardnav> -->
    <cradua-seismic-line-type [linenumbers]="linenumbers$ | async" (linenumber)="onSubmitLineNumber($event)" (deleteLineNumberEvent)="onDeleteLineNumber($event)"
      *ngIf="(isLoadingLineNumber$ | async ) === false">
    </cradua-seismic-line-type>
  
    <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingLineNumber$ | async) === true">
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
  